export function Notice() {
  return (
    <article className="space-y-4">
      <h3 className="text-lg font-bold">System Notice</h3>
      <div className="space-y-2 text-sm">
        <p>⚠ All non-critical files have been deleted from the system.</p>
        <p>Enhanced protection is now enabled.</p>
      </div>
    </article>
  );
}
